import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { formContextObj } from '../FormContainer';
import { getEstimation, clearAction as clearEstimationData } from '../../actions/getEstimation';
import { PriceEstimation } from '../../components/PriceEstimation';
import { selectEstimation } from '../../selectors/selectEstimation';
import { TThunkDispatch } from '../../types/redux';

export const PriceEstimationContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  // NOTE: данный контейнер и его данные не переводятся на RTK, т.к. вероятно он будет удалён
  const dispatch = useDispatch<TThunkDispatch>();
  const { data } = useSelector(selectEstimation);
  const { answersState } = React.useContext(formContextObj);

  React.useEffect(() => {
    dispatch(getEstimation({ answersState }));

    return () => {
      dispatch(clearEstimationData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) {
    return null;
  }

  return <PriceEstimation {...data} />;
};

PriceEstimationContainer.displayName = 'PriceEstimationContainer';
